import Vue from 'vue';
import rootStore from '@/store';
import chooseTargetCompanyStore from '../FormTabs/Detail/DetailFormStep/ChooseTargetCompany/store'
import chooseUnitStore from '../FormTabs/Detail/DetailFormStep/ChooseUnit/store'
import effectiveDateStore from '../FormTabs/Detail/DetailFormStep/EffectiveDate/store'
import verificationStore from '../FormTabs/Verification/store'
import paymentPreview from '../FormTabs/PaymentPreview/store'

export const unitChildTemplate = {
    orderDetailsId: 0,
    serialNumber: '',
    orderCode: '',
    batch: 0,
    selected: false,
    price: 0,
    orderStatus: 0,
    productId: 0,
    targetUnit: {
        orderId: 0,
        orderCode: '',
        batch: 0,
        isNew: false
    },
    leaseTag: null,
    startRent: '',
    endRent: '',
    errMessage: '',
}

export const unitTemplate = {
    orderCode: '',
    orderId: 0,
    batch: 0,
    billingCalculation: '',
    billingStart: '',
    customRecurringBillingDay: 0,
    billingPer: '',
    recurringBillingDay: '',
    selected: false,
    expanded: false,
    targetUnit: {
        orderId: 0,
        orderCode: '',
        batch: 0,
        isNew: false
    },
    startRent: '',
    endRent: '',
    children: [],
    errMessage: '',
    // isAllUnitUnavailable is used to determine if all children of the unit have error or not
    // if true, then all children have error, if false then some children have error, if null then no children have error
    isAllUnitUnavailable: null,
}

export const targetCompanyDataTemplate = {
    companyName: '',
    provinceName: '',
    cityName: '',
    districtName: '',
    village: '',
    postalCode: '',
    companyAddress: '',
    companyAktaAddress: '',
    citizenship: '',
    companyNpwp15: '',
    companyNameNPWP: '',
    companyNpwp16: '',
    companyNpwp22: '',
    companyPhone: '',
    source: '',
}
export const targetLesseeDataTemplate = {
    picName: "",
    picPhone: "",
    picDivision: "",
    picPosition: "",
}

const state = {
    ...chooseTargetCompanyStore.state,
    ...chooseUnitStore.state,
    ...effectiveDateStore.state,
    ...verificationStore.state,
    ...paymentPreview.state,
    status: '',
    ltCode: '',
    id: 0,
    /**NOTE - 
     * lease type, can be 'change-name' or 'transfer-unit'
     * */
    type: '',

    // Form Navigation
    currentStep: 1,

    // Others
    loading: false,
    loadingGetDetail: false,
};

const mutations = {
    ...chooseTargetCompanyStore.mutations,
    ...chooseUnitStore.mutations,
    ...effectiveDateStore.mutations,
    ...verificationStore.mutations,
    ...paymentPreview.mutations,
    SET_TRANSFER_UNIT_ID(state, value) {
        state.id = value;
    },
    SET_TYPE(state, value) {
        state.type = value;
    },

    // Form Navigation Mutations
    SET_CURRENT_STEP(state, step) {
        state.currentStep = step;
    },

    // Batch Update
    UPDATE_FORM_DATA(state, data) {
        Object.keys(data).forEach((key) => {
            if (state.hasOwnProperty(key)) {
                state[key] = data[key];
            }
        });
    },

    SET_TRANSFER_UNIT_ACTIVITY_LOG(state, value) {
        state.transferUnitActivityLog = value;
    },


    // Reset all state
    RESET_FORM_STATE(state) {
        state.status = '';
        state.ltCode = '';
        state.id = 0;
        state.companyIdOriginal = '';
        state.companyIdTarget = '';
        state.isNewCompany = null;
        state.targetCompany = {
            new: {
                companyIdTarget: '',
                newCompanyData: targetCompanyDataTemplate,
                newLesseeData: targetLesseeDataTemplate,
            },
            existing: {
                companyIdTarget: '',
                newCompanyData: targetCompanyDataTemplate,
                newLesseeData: targetLesseeDataTemplate,
            }
        };
        state.transferAllUnits = false;
        state.depositTransfer = null;
        state.reasonNoDepositTransfer = '';
        state.units = [];
        state.targetUnitOptions = [];
        state.effectiveMonth = '';
        state.clientRequestMidMonth = false;
        state.documentStatus = null;
        state.invoiceStatus = null;
        state.ticketStatus = null;
        state.lesseeStatus = null;
        state.transferUnitActivityLog = null;
        state.ticketLog = null;
        state.invoiceLog = null;
        state.currentStep = 1;
        state.isNewCompanyFormChanged = false
    },

    // others
    SET_LOADING(state, value) {
        state.loading = value
    },
    SET_LOADING_GET_DETAIL(state, value) {
        state.loadingGetDetail = value
    }
};

const actions = {
    ...chooseTargetCompanyStore.actions,
    ...chooseUnitStore.actions,
    ...verificationStore.actions,
    ...paymentPreview.actions,
    async getDetailTransferLessee({ commit }, value) {
        commit('SET_LOADING_GET_DETAIL', true);
        try {
            const response = await Vue.prototype.$http.get(process.env.GET_DETAIL_TRANSFER_UNIT + `/${value}`, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            })

            if (response.data.status === 200) {
                const {
                    id,
                    status,
                    ltCode,
                    companyIdOriginal,
                    companyIdTarget,
                    isNewCompany,
                    transferAllUnits,
                    companyData,
                    lesseeData,
                    depositTransfer,
                    depositTransferReason,
                    hasDepositTransfer,
                    depositAmount,
                    effectiveMonth,
                    effectiveDate,
                    selectedUnits,
                    clientRequestMidMonth,
                    termChecked,
                    leaseType,
                    paymentSchema
                } = response.data.content;

                const { companyEmail, fullAddress, ...cleanCompanyData } = companyData || targetCompanyDataTemplate;

                // fetch provinces, cities, and districts for select options
                if (cleanCompanyData.provinceName) {
                    const provinces = await rootStore.dispatch('others/fetchProvinces', null, { root: true });
                    const province = provinces.find((item) => item.provinceName === cleanCompanyData.provinceName);
                    if (province && cleanCompanyData.cityName) {
                        const cities = await rootStore.dispatch('others/fetchCities', (province.provinceId || '').toString(), { root: true });
                        const city = cities.find((item) => item.kabKotName === cleanCompanyData.cityName);
                        if (city && cleanCompanyData.districtName) {
                            await rootStore.dispatch('others/fetchDistricts', (city.cityId || '').toString(), { root: true });
                        }
                    }
                }

                const currentData = {
                    status,
                    ltCode,
                    action: "draft",
                    id,
                    companyIdOriginal,
                    companyIdTarget,
                    isNewCompany,
                    transferAllUnits,
                    depositTransfer: hasDepositTransfer,
                    depositAmount: 0,
                    reasonNoDepositTransfer: depositTransferReason,
                    clientRequestMidMonth,
                    termChecked,
                    type: leaseType === 'perubahan nama' ? 'change-name' : 'transfer-unit',
                }

                if (clientRequestMidMonth) {
                    currentData.midMonthEffectiveDate = effectiveDate
                } else {
                    currentData.effectiveMonth = effectiveMonth
                }

                let listOrderRenting = []
                let listNewOrder = []

                // This condition is requested by backend dev because he wont send anything
                // to GET_LESSEE_ORDER_RENTING response, currently the response 
                // will be null which is weird
                if (status !== 'draft') {
                    const responseUnitRenting = selectedUnits.reduce((acc, unit) => {
                        const isTargetUnitInListNewOrder = acc.listNewOrder.find((item) => item.newOrderId === unit.orderIdTarget)
                        const targetBatch = unit.orderTargetLabel.split(' ')[1]
                        if (!isTargetUnitInListNewOrder) {
                            acc.listNewOrder.push({
                                newOrderId: unit.orderIdTarget,
                                newOrderCode: unit.orderCodeTarget,
                                newBatch: Number(targetBatch),
                            })
                        }

                        let indexUnitInListOrderRenting = acc.listOrderRenting.findIndex((item) => item.orderId === unit.orderIdOriginal)
                        const originalBatch = unit.orderOriginalLabel.split(' ')[1]
                        if (indexUnitInListOrderRenting === -1) {
                            acc.listOrderRenting.push({
                                orderId: unit.orderIdOriginal,
                                orderCode: unit.orderCodeOriginal,
                                batch: Number(originalBatch),
                                items: []
                            })
                            indexUnitInListOrderRenting = acc.listOrderRenting.length - 1
                        }

                        const childUnit = {
                            endRent: unit.endRent,
                            startRent: unit.startRent,
                            errMessage: '',
                            orderCode: unit.orderCode,
                            orderDetailsId: unit.orderDetailsId,
                            orderStatus: 0,
                            productId: unit.productId,
                            serialNumber: unit.serialNumber,
                        }
                        acc.listOrderRenting[indexUnitInListOrderRenting].items.push(childUnit)
                        return acc
                    }, { listOrderRenting: [], listNewOrder: [] })

                    listOrderRenting = responseUnitRenting.listOrderRenting
                    listNewOrder = responseUnitRenting.listNewOrder

                } else {
                    // Parse Unit data by request all renting units from API
                    const responseUnitRenting = await Vue.prototype.$http.post(process.env.GET_LESSEE_ORDER_RENTING, {
                        companyIdOriginal,
                        companyIdTarget,
                        ltId: id
                    }, {
                        headers: { 'Asani-Token': localStorage.getItem('jwt') }
                    });
                    listOrderRenting = responseUnitRenting.data.content.listOrderRenting || []
                    listNewOrder = responseUnitRenting.data.content.listNewOrder || []
                }

                // Get all available order code from response
                const allOrderCode = listNewOrder ? listNewOrder.map((item) => {
                    return {
                        isNew: true,
                        orderCode: item.newOrderCode,
                        batch: item.newBatch,
                        orderId: item.newOrderId
                    }
                }) : []

                let units = listOrderRenting.map((item) => {
                    // Store unit based on unit template
                    const newUnit = { ...unitTemplate }
                    const keys = Object.keys(unitTemplate)
                    keys.forEach((key) => {
                        newUnit[key] = item[key] || newUnit[key]
                    })

                    // parse children of unit
                    const children = item.items.map((child) => {
                        const newChild = { ...unitChildTemplate }
                        const keys = Object.keys(unitChildTemplate)
                        keys.forEach((key) => {
                            newChild[key] = child[key] || newChild[key]
                        })

                        if (newChild.errMessage.length <= 0) {
                            // check if the child is exist in current transfer unit detail data
                            const existingData = selectedUnits.find((el) => el.orderIdOriginal === item.orderId && el.serialNumber === child.serialNumber)
                            // if exist the set the target unit of the child and set the selected to true
                            if (existingData) {
                                // get the existed order code from all order code that have been parsed above
                                const existedOrderCode = allOrderCode.find((el) => el.orderId === existingData.orderIdTarget)
                                if (!existedOrderCode) return newChild;
                                newUnit.selected = true
                                newChild.selected = true

                                // set target unit for the new unit first if it doesnt exist
                                if (!newUnit.targetUnit.orderCode && existedOrderCode) {
                                    newUnit.targetUnit = existedOrderCode
                                }

                                // if new unit target unit is not same with the existed order code, 
                                // then set child target unit to existed order code
                                newChild.targetUnit = existedOrderCode
                            }
                        }

                        return newChild
                    })

                    // Validate if all children have error, some children have error, or no children have error
                    newUnit.errMessage = "Terdapat beberapa unit yang tidak bisa dialihkan. Buka rows untuk lihat detail."
                    const isAllChildrenError = children.every((child) => child.errMessage.length > 0)
                    const isSomeChildrenError = children.some((child) => child.errMessage.length > 0)
                    if (isAllChildrenError) {
                        newUnit.isAllUnitUnavailable = true
                    }
                    if (isSomeChildrenError && !isAllChildrenError) {
                        newUnit.isAllUnitUnavailable = false
                    }
                    if (!isSomeChildrenError) {
                        newUnit.isAllUnitUnavailable = null
                        newUnit.errMessage = ""
                    }

                    newUnit.children = children
                    newUnit.startRent = children[0].startRent
                    newUnit.endRent = children[0].endRent
                    return newUnit
                })

                // Set lease tag based on payment schema if available
                if (paymentSchema) {
                    commit('SET_PAYMENT_SCHEMA', paymentSchema);
                    units = units.map((unit) => {
                        unit.children = unit.children.map((child) => {
                            if (!child.targetUnit || !child.targetUnit.orderCode) return child;
                            const childPaymentSchema = paymentSchema.find((item) => item.orderCode === child.targetUnit.orderCode)
                            if (childPaymentSchema) {
                                child.leaseTag = childPaymentSchema.leaseTag
                            }
                            return child
                        })
                        return unit
                    })
                }

                const currentCompanyData = {
                    companyIdTarget,
                    newCompanyData: cleanCompanyData,
                    newLesseeData: lesseeData || targetLesseeDataTemplate,
                }

                if (isNewCompany) {
                    commit('SET_TARGET_COMPANY_NEW', currentCompanyData);
                } else {
                    commit('SET_TARGET_COMPANY_EXISTING', currentCompanyData);
                }
                commit('SET_ALL_UNIT_RENTING', units);
                commit('SET_TARGET_UNIT_OPTIONS', allOrderCode.map((item) => {
                    return {
                        value: item,
                        label: item
                    }
                }));


                commit('UPDATE_FORM_DATA', currentData);
                return {
                    isSuccess: true,
                    data: {
                        status
                    }
                }
            } else {
                return {
                    isSuccess: false,
                    message: response.data.message
                }
            }
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message
                : 'An error occurred while fetching transfer unit details.';
            return {
                isSuccess: false,
                message: errorMessage
            }
        } finally {
            commit('SET_LOADING_GET_DETAIL', false);
        }
    },

    async saveDetail({ commit, state }, { value, type }) {
        const leaseTypeValue = {
            'change-name': 'perubahan nama',
            'transfer-unit': 'pengalihan unit',
        }
        const { type: leaseType, paymentSchema } = state
        const {
            companyIdOriginal,
            companyIdTarget,
            units,
            depositTransfer,
            effectiveMonth,
            clientRequestMidMonth,
            midMonthEffectiveDate,
            reasonNoDepositTransfer,
            targetCompany,
            id,
            transferAllUnits,
            isNewCompany,
            termChecked
        } = value

        let companyData, lesseeData;
        if (isNewCompany) {
            companyData = targetCompany.new.newCompanyData;
            lesseeData = targetCompany.new.newLesseeData;
        } else {
            companyData = targetCompany.existing.newCompanyData;
            lesseeData = targetCompany.existing.newLesseeData;
        }

        const sentData = {
            action: type || "draft",
            id,
            leaseType: leaseTypeValue[leaseType] || leaseType,
            companyIdOriginal,
            companyIdTarget: companyIdTarget || 0,
            isNewCompany,
            transferAllUnits,
            companyData,
            lesseeData,
            hasDepositTransfer: depositTransfer,
            depositTransferReason: reasonNoDepositTransfer,
            clientRequestMidMonth,
            termChecked,
            selectedUnits: [],
            paymentSchema: paymentSchema || [],
        }

        if (effectiveMonth || midMonthEffectiveDate) {
            if (clientRequestMidMonth) {
                let splitDate = midMonthEffectiveDate.split("-");
                sentData.effectiveMonth = `${splitDate[0]}-${splitDate[1]}`
                sentData.effectiveDate = midMonthEffectiveDate
            } else {
                let splitDate = effectiveMonth.split("-");
                sentData.effectiveMonth = `${splitDate[0]}-${splitDate[1]}`
                const nextMonthDate = new Date(sentData.effectiveMonth + "-01");
                nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
                let nextMonth = nextMonthDate.getMonth() + 1
                nextMonth = String(nextMonth).padStart(2, '0');
                sentData.effectiveDate = `${nextMonthDate.getFullYear()}-${nextMonth}-01`
            }

        }

        if (units && units.length > 0) {
            units.forEach((unit) => {
                unit.children.forEach((child) => {
                    if (!child.error && child.selected) {
                        let orderCodeTarget = unit.targetUnit.orderCode
                        let orderIdTarget = unit.targetUnit.orderId

                        // check if child has target Unit
                        if (child.targetUnit.orderCode) {
                            orderCodeTarget = child.targetUnit.orderCode
                            orderIdTarget = child.targetUnit.orderId
                        }
                        let orderTargetLabel = `Batch ${child.targetUnit.batch}`
                        if (!child.targetUnit.batch) {
                            orderTargetLabel = `Batch ${unit.targetUnit.batch}`
                        }
                        sentData.selectedUnits.push({
                            orderIdOriginal: unit.orderId,
                            orderCodeOriginal: unit.orderCode,
                            orderDetailsId: child.orderDetailsId,
                            serialNumber: child.serialNumber,
                            orderCode: child.orderCode,
                            productId: child.productId,
                            orderIdTarget,
                            orderCodeTarget,
                            orderTargetLabel,
                            startRent: child.startRent,
                            endRent: child.endRent
                        })
                    }
                })
            })
        }

        commit('SET_LOADING', true);
        try {
            const response = await Vue.prototype.$http.post(process.env.SAVE_TRANSFER_UNIT_DATA, sentData, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            })
            if (response.data.status == 200) {
                commit("SET_TRANSFER_UNIT_ID", response.data.content);
                return {
                    isSuccess: true
                }
            }
            return {
                isSuccess: false,
                message: response.data.message
            }
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred while saving the data.';
            return {
                isSuccess: false,
                message: errorMessage
            }
        } finally {
            commit('SET_LOADING', false);
        }
    },

    // Reset
    resetFormState({ commit }) {
        commit('RESET_FORM_STATE');
    },

    // List Rent Adjustment
    async getListRentAdjustment({ commit }, value) {
        try {
            const response = await Vue.prototype.$http.post(process.env.SEARCH_TRANSFER_UNIT, value, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            })
            if (response.data.status == 200) {
                return response.data.content;
            } else {
                return [];
            }
            return response.data.content;
        } catch (error) {
            return [];
        }
    },

    async updateStatusTransferUnit({ commit }, { transferUnitId, status, reason }) {
        commit('SET_LOADING', true);
        try {
            const response = await Vue.prototype.$http.post(process.env.TRANSFER_UNIT_UPDATE_STATUS, {
                id: transferUnitId,
                status,
                reason
            }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            });
            if (response.data.status === 200) {
                return {
                    isSuccess: true
                }
            }
            return {
                isSuccess: false,
                message: response.data.message
            };
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message
                : 'An error occurred while updating the status.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async reprocessTransferUnitExecution({ commit }, { transferUnitId }) {
        commit('SET_LOADING', true);
        try {
            const response = await Vue.prototype.$http.post(process.env.EXECUTE_TRANSFER_UNIT, {
                ltId: transferUnitId
            }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            });
            if (response.data.status === 200) {
                return {
                    isSuccess: true
                }
            }
            return {
                isSuccess: false,
                message: response.data.message
            };
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message
                : 'An error occurred while reprocessing the execution.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    }
};

const getters = {
    ...chooseTargetCompanyStore.getters,
    ...chooseUnitStore.getters,
    ...verificationStore.getters,
    ...paymentPreview.getters,
    getStatus: (state) => state.status,
    getLtCode: (state) => state.ltCode,
    getId: (state) => state.id,
    getType: (state) => state.type,

    // Form Navigation Getters
    getCurrentStep: (state) => state.currentStep,

    getFormData: (state) => ({
        id: state.id,
        companyIdOriginal: state.companyIdOriginal,
        companyIdTarget: state.companyIdTarget,
        targetCompany: state.targetCompany,
        isNewCompany: state.isNewCompany,
        newLesseeData: state.newLesseeData,
        transferAllUnits: state.transferAllUnits,
        depositTransfer: state.depositTransfer,
        units: state.units,
        effectiveMonth: state.effectiveMonth,
        clientRequestMidMonth: state.clientRequestMidMonth,
        reasonNoDepositTransfer: state.reasonNoDepositTransfer,
        midMonthEffectiveDate: state.midMonthEffectiveDate,
        termChecked: state.termChecked
    }),
    getLoading: (state) => state.loading,
    getLoadingGetDetail: (state) => state.loadingGetDetail,
    getDisabledNotDraft: (state) => state.status !== "draft" && Boolean(state.id),
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/components/RentAdjustment/Store/index.js